import { baseUrl, fetchWithAuth } from "./index";

export async function listRealEstates() {
  const response = await fetchWithAuth(`${baseUrl}/real_estates/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.map((item) => ({
    id: item.id,
    full_name: item.name,
    document: item.cnpj,
    email: item.email,
    current_month_payment_status: item.current_month_payment_status,
    position: "common",
    payments: item.payments,
    isRealEstate: true,
    type: item.type, // Ensure 'type' is included, defaulting to 'common' if not present
    is_payer: item.is_payer,
  }));
}

export async function getRealEstate(id) {
  const response = await fetchWithAuth(`${baseUrl}/real_estates/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return {
    id: response.id,
    full_name: response.name,
    document: response.cnpj,
    email: response.email,
    current_month_payment_status: response.current_month_payment_status,
    position: "common",
    payments: response.payments,
    isRealEstate: true,
  };
}

export async function deleteRealEstate(id) {
  const response = await fetchWithAuth(`${baseUrl}/real_estates/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (response.error) {
    const errorText = await response.text;
    console.error("Erro da API:", errorText);
    throw new Error("Failed to delete real estate");
  }
}

export async function createRealEstate(data) {
  return await fetchWithAuth(`${baseUrl}/real_estates/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}

export async function updateRealEstate(id, data) {
  return await fetchWithAuth(`${baseUrl}/real_estates/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}
